import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Footer = () => {
  const { FiTarget, FiFacebook, FiInstagram, FiLinkedin, FiMapPin, FiPhone } = FiIcons;

  const socialLinks = [
    { 
      icon: FiFacebook, 
      url: 'https://www.facebook.com/NuInteractiveMedia',
      label: 'Facebook'
    },
    { 
      icon: FiInstagram, 
      url: 'https://www.instagram.com/nuinteractivemedia',
      label: 'Instagram'
    },
    { 
      icon: FiLinkedin, 
      url: 'https://www.linkedin.com/company/clarkritchotte',
      label: 'LinkedIn'
    }
  ];

  return (
    <footer className="bg-slate-950 border-t border-slate-900 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-6">
              <SafeIcon icon={FiTarget} className="text-3xl text-blue-500" />
              <span className="text-xl font-bold text-white uppercase tracking-tighter">NYC<span className="text-blue-500">SEO</span>.agency</span>
            </Link>
            <p className="text-slate-400 text-sm mb-6 leading-relaxed">
              The premier NYC SEO Agency specializing in Generative Engine Optimization (GEO), AI Search Visibility, and Local SEO for Manhattan, Brooklyn, and beyond.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, i) => (
                <a 
                  key={i} 
                  href={social.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-500 hover:text-blue-500 transition-colors p-2 bg-slate-900 rounded-lg border border-slate-800 hover:border-blue-500/50"
                  aria-label={social.label}
                >
                  <SafeIcon icon={social.icon} className="text-xl" />
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">NYC SEO Services</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/services/enterprise-seo" className="hover:text-blue-400">Enterprise SEO NYC</Link></li>
              <li><Link to="/nyc-local-seo" className="hover:text-blue-400">Local SEO Optimization</Link></li>
              <li><Link to="/geo-ai-optimization" className="hover:text-blue-400">GEO & AI Search Optimization</Link></li>
              <li><Link to="/services/technical-seo" className="hover:text-blue-400">Technical SEO Audits</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">Boroughs We Serve</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/nyc-local-seo" className="hover:text-blue-400">Manhattan SEO</Link></li>
              <li><Link to="/nyc-local-seo" className="hover:text-blue-400">Brooklyn SEO</Link></li>
              <li><Link to="/nyc-local-seo" className="hover:text-blue-400">Queens SEO</Link></li>
              <li><Link to="/nyc-local-seo" className="hover:text-blue-400">The Bronx SEO</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">Contact Us</h4>
            <ul className="space-y-4 text-sm text-slate-400">
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="text-blue-500 mt-1 flex-shrink-0" />
                <span>200 Broadway<br />Floor 3<br />New York, NY 10038</span>
              </li>
              <li className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-blue-500 flex-shrink-0" />
                <span>(212) 555-0198</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-900 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-slate-600">
          <p>&copy; {new Date().getFullYear()} Clark-Ritchotte Communications. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;